// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { installHCaptchaBridge } from "./lib/dwm_hcaptcha_bridge.mjs"

installHCaptchaBridge()
